module.exports = __webpack_public_path__ + "img/bg_lbsq.264314ae.svg";